var ListItem = /** @class */ (function () {
    function ListItem() {
    }
    return ListItem;
}());
export { ListItem };
var MyException = /** @class */ (function () {
    function MyException(status, body) {
        this.status = status;
        this.body = body;
    }
    return MyException;
}());
export { MyException };
//# sourceMappingURL=multiselect.model.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular2-multiselect-dropdown/multiselect.model.js
// module id = 662
// module chunks = 9